import { render, staticRenderFns } from "./user-profile.html?vue&type=template&id=73f80b08&scoped=true&"
import script from "./user-profile.js?vue&type=script&lang=js&"
export * from "./user-profile.js?vue&type=script&lang=js&"
import style0 from "./user-profile.scss?vue&type=style&index=0&id=73f80b08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f80b08",
  null
  
)

export default component.exports